/**
 * Pure skip rules for the tab-resume link-liveness probe.
 * Spec: docs/specs/tab-resume-link-liveness.md
 */

export const LINK_LIVENESS_DEBOUNCE_MS = 300;

export type LinkLivenessSkipReason =
  | "no-link-id"
  | "dead-link-route"
  | "claim-in-flight"
  | "probe-in-flight"
  | "debounce";

export function shouldSkipLinkLivenessProbe(args: {
  linkId: string | null;
  pathname: string;
  deadLinkPaths: readonly string[];
  claimInFlight: boolean;
  probeInFlight: boolean;
  lastAttemptAt: number | null;
  now: number;
  debounceMs?: number;
}): LinkLivenessSkipReason | null {
  if (!args.linkId) return "no-link-id";
  if (args.deadLinkPaths.includes(args.pathname)) return "dead-link-route";
  if (args.claimInFlight) return "claim-in-flight";
  if (args.probeInFlight) return "probe-in-flight";
  const debounce = args.debounceMs ?? LINK_LIVENESS_DEBOUNCE_MS;
  if (args.lastAttemptAt != null && args.now - args.lastAttemptAt < debounce) {
    return "debounce";
  }
  return null;
}
